// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-box[data-v-1d12c515]{min-width:20px;height:20px;border:1px solid var(--v-accentBlue-base);background:#fff;border-radius:5px;display:flex;align-items:center;justify-content:center}.select-box i[data-v-1d12c515]{height:100%}.select-box.selected[data-v-1d12c515]{background:var(--v-accentBlue-base)}.select-box.disabled[data-v-1d12c515]{border:1px solid var(--v-modalGray-darken1);background:var(--v-modalGray-base)}", ""]);
// Exports
module.exports = exports;
